import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectAuthReady,
  selectCurrentToken,
  selectCurrentRoles,
} from "./authSlice";
import LoadingSpinner from "../../components/loader/Loader";

const RequireAuth = ({ allowedAppRoles = [] }) => {
  const token = useSelector(selectCurrentToken);
  const appRoles = useSelector(selectCurrentRoles);
  const authReady = useSelector(selectAuthReady);
  const location = useLocation();

  if (!authReady) {
    return <LoadingSpinner />;
  }

  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  let hasAppRoleAccess = true;
  if (allowedAppRoles.length > 0) {
    hasAppRoleAccess = appRoles.some((role) => allowedAppRoles.includes(role));
  }

  const hasAccess = hasAppRoleAccess;

  return hasAccess ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default RequireAuth;